import { supabaseClient } from "@/lib/supabase";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import type { Template } from "@/types/database/diaries";
import { useNavigate } from "@tanstack/react-router";

export const upsertTemplate = async (template: Template["Insert"]) => {
	const { data, error } = await supabaseClient
		.from("templates")
		.upsert(template)
		.select()
		.single();

	if (error) throw error;
	return data;
};

export const useUpsertTemplate = () => {
	const queryClient = useQueryClient();
	const navigate = useNavigate();

	return useMutation({
		mutationFn: upsertTemplate,
		onSuccess: () => {
			toast.success("Template saved successfully");
			navigate({ to: "/new/diary/complete" });
		},
		onError: (error) => {
			toast.error("Failed to save template");
			console.error("Template save error:", error);
		},
		onSettled: () => {
			queryClient.invalidateQueries({ queryKey: ["templates"] });
		},
	});
};
